module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/modal-profile-3-image-3ad7e74d4cb2c780fac48ac29aa3526f.png";